"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Unit = void 0;
const i18n_1 = require("../../i18n");
const mithril_1 = require("../../mithril");
const theme_1 = require("../theme");
const CSS = {
    unit: 'c-unit'
};
const Style = {
    [CSS.unit]: {
        'font-weight': theme_1.DefaultTheme.font.weight.bold,
        'margin-left': theme_1.DefaultTheme.space(1),
        'margin-right': theme_1.DefaultTheme.space(2)
    }
};
(0, theme_1.addStyles)(Style);
exports.Unit = {
    view(name) {
        return (0, mithril_1.m)('sup', { className: CSS.unit }, (0, i18n_1.Translate)(name));
    }
};
//# sourceMappingURL=unit.js.map